import { put, takeLatest, call, select } from 'redux-saga/effects';

import isEmpty from 'lodash/isEmpty';

import { addCustomGTMEvent } from '../../../events/googleTagManager';
import { formatError } from '../../../libs';
import cartAPI from '../../api/cart';
import checkoutAPI from '../../api/checkout';
import { Creators as CartCreators } from '../../reducers/cart';
import { Types, Creators as CheckoutCreators } from '../../reducers/checkout';
import { setCookie, getLeadCookie } from '../../utils/cookies';
import getState from '../../utils/getState';
import getToken from '../../utils/getToken';

function* checkoutRequest({ cid, validCart = false, cartData = {}, ctx = null }) {
  try {
    const { cart, app } = yield select(getState);
    const token = yield select(getToken);

    const siteId = app.getIn(['config', 'siteId']);
    const domain = app.getIn(['config', 'domain']);
    let cartId = cid || cart.getIn(['id']);

    let newCart = cartData;

    if (!validCart) {
      const verifyCartIsFinalized = yield call(checkoutAPI.verifyCartIsFinalized.get, cartId, token, siteId);

      if (!isEmpty(verifyCartIsFinalized)) {
        const rescue = yield call(cartAPI.getRescueCart, cartId, siteId);
        newCart = yield call(cartAPI.getCart, rescue.id, token, siteId);

        cartId = rescue.id;
        setCookie('cart.id', cartId, ctx, { expires: 4, domain });

        yield put(CartCreators.cartSuccess(newCart));
      }
    }

    const data = yield call(checkoutAPI.checkout, cartId, token, siteId);

    yield put(CartCreators.cartSuccess(newCart));
    yield put(CheckoutCreators.checkoutSuccess(data));
  } catch (error) {
    yield put(CheckoutCreators.checkoutFailed(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.CHECKOUT_REQUEST, checkoutRequest);
}
